<template>
<div class="videopage">
    <video src="../assets/img/video2.mp4" controls x5-playsinline playsinline webkit-playsinline></video>
</div>
</template>

<style lang="less" scoped>
.videopage {
    video {
        width: 100%;
        height: auto;
    }
}
</style>

<script>
export default {
    name: 'videopage'
}
</script>



// WEBPACK FOOTER //
// src/view/video.vue